export class Appointment {
    public bookingType: number = PartyType.Individual;
    public clinic: string = null;
    public departDate: any;
    public returnDate: any;
    public reason: string = null;
    public accomodationType: any;
    public destinationTravel: any;
    public destination: string;
    public note: string;
    public groupName: string;
    public paymentTerm: string = null;
    public id: string;
    public bookingREF: any;
    public date: any;
    public fromTime: any;
    public toTime: any;
    public startTime: string;
    public endTime: string;
    public numberOfAttending: number;
    public travelDestination: Array<any>;
    public reasonsForTrip: string;
    public typeOfAccommodation: string;
    public status: any;
    public clinicId: string = null;
    public listMembers: Array<MemberModel>;
    public centre: string = null;
    public clinicName: string;
    public typeOfAccommodationId: any;
    public travelDestinationId: Array<any>;
    public reasonsForTripId: any;
    public typeOfAccommodationName: any;
    public travelDestinationName: any;
    public reasonsForTripName: any;
    public durationId: string = null;
    public duration: number;
    public administeredDate: any;
    public typeAccommodation: any;
    public reasonTrip: Array<any>;
    public centreId: string = null;
}
export class MemberModel{
    public partyType : any;
    public Title : string;
    public firstName : string;
    public surName : string;
    public sex : string;
    public dateOfBirth : any;
    public mobilePhone : string;
    public email : string;
    public CountryOfBirthId : string;
    public MainContact : string;
    public OccupationId : string;
    public Address1 : string;
    public Address2 : string;
    public CountryId : string;
}
export enum PartyType {
    Individual = 0,
    Group = 1
}

export class ImportFormModel {
  public isFileDelete: boolean;
  public fileName: string;
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/models/request-appointment/appointment.model.ts